import { mapState, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapState({ me: state => state.user.me }),
        ...mapGetters(['isAgency']),

        isUserRolesAuthorized () {
            const rolesName = _.map(this.me.roles, 'name')

            return rolesName.some((r) => {
                const managerRolesName = ['manager', 'administrator', 'super-administrator']

                return managerRolesName.includes(r)
            }) && !rolesName.includes('premium-agency')
        }
    }
}



// WEBPACK FOOTER //
// ./client/mixins/user.js